export const cepFormatter = (cep: string): string => {
  if (cep.length === 8) {
    return `${cep.substring(0, 5)}-${cep.substring(5, cep.length)}`;
  }
  return cep;
};
